import { Client } from "./client";
import { EvidenceSubmissionCreateData } from "@/backend/access/evidenceSubmission/types";
import { EvidenceSubmissionCreateResponse, EvidenceSubmissionListResponse, EvidenceSubmissionUpdateResponse } from "@/backend/express/controllers/evidenceSubmissionController";
import { ReviewerOutcome, SubmitterOutcome } from "@/backend/models/evidenceSubmission";
import { FusaReply } from "@/types/replyTypes";

export class EvidenceSubmissionController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  create(data: EvidenceSubmissionCreateData): Promise<EvidenceSubmissionCreateResponse> {
    return this.client.create("/api/evidence-submissions", data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/evidence-submissions/${id}`);
  }

  updateSubmitterOutcome(outcomes: Record<string, SubmitterOutcome>): Promise<EvidenceSubmissionListResponse> {
    return this.client.update(`/api/evidence-submissions/updateOutcomes`, { outcomes });
  }

  updateReviewerOutcome(id: string, reviewerOutcome: ReviewerOutcome, reviewComment: string): Promise<EvidenceSubmissionUpdateResponse> {
    return this.client.update(`/api/evidence-submissions/${id}/reviewer-outcome`, { reviewerOutcome, reviewComment });
  }
}
